import React, { useState } from 'react';
import { useMediaQuery } from '@react-hook/media-query';
import Principal from '../home/Principal';
import AboutUs from '../home/AboutUs';
import Services from '../home/Services';
//import Portfolio from '../home/Portfolio';
import Contact from '../home/Contact';
import '../../styles.css'; // Estilos generales
//import Footer from '../principals/Footer';

const Home = ({ menuOpen }) => {
  const isSmallScreen = useMediaQuery('(max-width: 768px)'); // Define una condición para pantallas pequeñas
  
  const [height, setHeight] = useState(isSmallScreen ? '75vh' : 'auto'); // Estado para controlar la altura del componente

  // Actualizar la altura del componente cuando el menú está abierto o el tamaño de la pantalla cambia
  React.useEffect(() => {
      if (menuOpen) {
          setHeight(isSmallScreen ? '75vh' : 'auto');
      } else {
          setHeight(isSmallScreen ? '100%' : 'auto');
      }
  }, [menuOpen, isSmallScreen]); 

  return (
      <div className="home-component" style={{ height }}>
          <Principal />
          <AboutUs />
          <Services />
          <Contact />
      </div>
  );
}

export default Home;
